import { baseService } from './baseService'
import Response from '../data/entity/response_entity'

import { STATUS_CODE } from '../data/system_settings'

class AccountGroupService extends baseService {
  async getAll() {
    try {
      const res = await this.get('groups/')
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Vui lòng liên hệ admin',
          },
        })
      }
    } catch (error) {
      handleError(error)
    }
  }
  async addGroup(payload) {
    try {
      const res = await this.post('groups/', payload)
      if (res.status === STATUS_CODE.CREATED) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Vui lòng liên hệ admin',
          },
        })
      }
    } catch (error) {
      handleError(error)
    }
  }
}
const handleError = (error) => {
  let message = error.message || 'Lỗi không xác định'
  if (error.response) {
    const { status, data } = error.response
    message = data.error || 'Lỗi không xác định'
    if (status === STATUS_CODE.BAD_REQUEST) {
      message = 'Vui lòng kiểm tra lại dữ liệu'
    }
  }
  return Response({ success: false, message: { content: message } })
}

export const accountGroupService = new AccountGroupService()
